/**
 * Theme Manager - Automatska detekcija i upravljanje temom
 * PC Centar Enhanced
 */

class ThemeManager {
  constructor() {
    this.theme = this.getPreferredTheme();
    this.init();
  }

  init() {
    // Postavi početnu temu
    this.applyTheme(this.theme);
  }

  getPreferredTheme() {
    const saved = localStorage.getItem('theme-preference');
    if (saved) {
      return saved;
    }

    return 'light';
  }

  setTheme(theme) {
    this.theme = theme;
    this.applyTheme(theme);
    localStorage.setItem('theme-preference', theme);
    
    // Emit custom event za komponente
    window.dispatchEvent(new CustomEvent('themeChanged', { 
      detail: { theme } 
    }));
  }

  applyTheme(theme) {
    const root = document.documentElement;
    
    if (theme === 'dark') {
      root.setAttribute('data-theme', 'dark');
      root.classList.add('dark');
    } else {
      root.setAttribute('data-theme', 'light');
      root.classList.remove('dark');
    }
  }

  toggleTheme() {
    const newTheme = this.theme === 'dark' ? 'light' : 'dark';
    this.setTheme(newTheme);
    return newTheme;
  }

  getCurrentTheme() {
    return this.theme;
  }

  isDark() {
    return this.theme === 'dark';
  }

  isLight() {
    return this.theme === 'light';
  }
}

// Kreacija globalne instance
const themeManager = new ThemeManager();

// Export kao default i named
export default themeManager;
export { ThemeManager };

// Dodaj na window za pristup iz bilo kog dela aplikacije
if (typeof window !== 'undefined') {
  window.themeManager = themeManager;
}
